import styles from './style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import useInvoicesTickets from '../useInvoicesTickets';
import UIHelper from '../../../../../helpers/UIHelper';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    title,
    data,
    columns,
    format,
    loading,
    summary,
    searchParams,
    filters,
  } = useInvoicesTickets(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>Tickets</Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col xs={24} xxl={12}>
              <Table
                loading={loading}
                columns={UIHelper.assignTire(columns)}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                summary={summary}
                scroll={{}}
              />
            </Col>
            <Col span={12} className={'chartColl'}>
              <LineChart
                data={data.lineChartData}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
              />
              <br />
              <BarChangeChart
                keys={['Pezzi LY', 'Pezzi YTD']}
                data={data}
                format={format}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
